import angular from 'angular';
import moment from 'moment';

import { getErrorMessage } from 'application/util/error.util';

import './subscription.style.sass';
import template from './subscription.tpl.pug';

const SUBSCRIPTION_TYPE_ANDROID     = 'android';
const SUBSCRIPTION_TYPE_IOS         = 'ios';
const SUBSCRIPTION_TYPE_AVANGATE    = 'avangate';

const STORE_NAME = {
    [SUBSCRIPTION_TYPE_ANDROID]: 'Google Play Store',
    [SUBSCRIPTION_TYPE_IOS]: 'Apple App Store',
    [SUBSCRIPTION_TYPE_AVANGATE]: 'Avangate'
};

const DEVICE_NAME = {
    [SUBSCRIPTION_TYPE_ANDROID]: 'Android device',
    [SUBSCRIPTION_TYPE_IOS]: 'iOS device',
    [SUBSCRIPTION_TYPE_AVANGATE]: 'browser'
};

class SubscriptionSettingsController {
    /* @ngInject */
    constructor($q, planService, configuration, notificationService) {
        this.$q = $q;
        this.planService = planService;
        this.configuration = configuration;
        this.notificationService = notificationService;
    }

    $onInit() {
        this.cancelSubscriptionHelpCenterUrl = this.configuration.cancelSubscriptionHelpCenterUrl;
        this.plan = this.plan || {};
        this.loading = true;

        this.loadSubscriptionInfo().finally(() => {
            this.loading = false;
        });
    }

    loadSubscriptionInfo() {
        return this.planService.getSubscriptionInfo().then((data) => {
            this.plan = this.buildPlanFromSubscriptionInfo(data);
            this.applyPlan(this.plan);
        }).catch((error) => {
            this.notificationService.showError(getErrorMessage(error, `We were not able to retrieve your subscription information.`));
            this.processing = true;
            return this.$q.reject(error);
        });
    }

    buildPlanFromSubscriptionInfo(data) {
        let billing = data && data.billingInfo ? data.billingInfo : {};

        return angular.merge({}, data ? data.plan || {} : {}, {
            subscription: angular.merge({}, data && data.plan ? data.plan.subscription || {} : {}, {
                price: billing.price || null,
                currency: billing.currency || null
            })
        });
    }

    applyPlan(plan) {
        let subscription = plan && plan.subscription || {};
        let date = moment(subscription.endDate);

        this.endTimestamp = subscription.endDate;
        this.endDate = this.canExpire(date) ? date.format('dddd, Do MMMM YYYY') : null;
        this.recurring = subscription.recurring;
        this.store = this.getStoreName(subscription.type);
        this.device = this.getDeviceName(subscription.type);
        this.price = this.formatPrice(subscription.currency, subscription.price);
        this.features = plan && plan.features ? plan.features : [];
        this.expired = !!(plan && plan.expired);
        this.processing = !subscription.type;
    }

    formatPrice(currency, price) {
        return currency && price
            ? `${currency} ${Number.prototype.toFixed.call(price, 2)}`
            : null;
    }

    canExpire(date) {
        date = moment(date);
        return date.isValid() && date.year() < 2100;
    }

    getStoreName(type) {
        return STORE_NAME[type] || 'Unknown';
    }

    getDeviceName(type) {
        return DEVICE_NAME[type] || 'unknown device';
    }
}

export default {
    selector: 'dbASubscriptionSettings',
    template: template(),
    controller: SubscriptionSettingsController,
    bindings: {
        plan: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/subscription/subscription.cmpt.js